<div style="max-width: 1700px; margin: 0 auto;">

  <!-- TABLAS POR VEHICULO -->
  <ng-container *ngIf="!report.filters.includeOnlyTable && !report.filters.includeSimultaneousTables">
    <div *ngFor="let vehicleData of vehicleData.vehicles" class="p-card" style="padding: 0.8rem;">

      <div class="subtable-title mb-3">
        <div>
          <div>VEHÍCULO</div>
          <div>{{ vehicleData.vehicle.name }}</div>
        </div>
        <div>
          <div>PERIODO</div>
          <div>{{ report.reportDetails.periodRange }}</div>
        </div>
      </div>

      <ng-container *ngIf="vehicleData.records.length >= 0">
        <app-report-table
          [columns]="columns"
          [rows]="vehicleData.records"
          [report]="report"
          [withButtonGeneral]="withButtonGeneral"
          [withButtonDriversList]="buttonUpdateDriverList"
          [imei]="vehicleData.vehicle.imei"
          [vehicleName]="vehicleData.vehicle.name"
          [scrollHeight]="'calc(100vh - var(--report-table-scrollOffset))'"
        >
        </app-report-table>
      </ng-container>
<!-- 
      <div *ngIf="vehicleData.records.length === 0" class="p-card text-left" style="padding: 1rem;">
        <p>Ningún dato encontrado en su consulta.</p>
      </div> -->

      <div *ngIf="vehicleData.summary">
        <app-report-summary
          [summary]="vehicleData.summary"
        >
        </app-report-summary>
      </div>

    </div>
  </ng-container>

  <!-- TABLA UNICA -->
  <ng-container *ngIf="report.filters.includeOnlyTable && vehicleData">
    <div class="p-card" style="padding: 0.8rem;">
      <div class="subtable-title mb-3">
        <div>
          <div>PERIODO</div>
          <div>{{report.reportDetails.periodRange}}</div>
        </div>
      </div>

      <ng-container class="table-container" style="width: 100%; overflow-x: auto;">
        <app-report-table
          [columns]="columns"
          [rows]="vehicleAllRecords"
          [type]="VIRTUAL_SCROLL"
          [report]="report"
          [withButtonGeneral]="withButtonGeneral"
          [scrollHeight]="'calc(100vh - var(--report-table-scrollOffset))'"
        >
        </app-report-table>
      </ng-container>

      <div *ngIf="vehicleAllRecords.length === 0" class="p-card text-left" style="padding: 1rem;">
        <p>Ningún dato encontrado en su consulta.</p>
      </div>

    </div>
  </ng-container>
</div>
